import { useCallback, useEffect, useState } from "react";

import { api } from "@/api";
import { useAuth } from "@/auth";

import "@/themes/rapport/app.css";
import "@/themes/rapport/overview.css";
import "@/themes/rapport/pipeline.css";
import "@/themes/rapport/customers.css";
import "@/themes/rapport/bridge.css";
import "@/themes/rapport/crm.css";
import "@/themes/rapport/dark-legacy.css";

// Thèmes installés : un dossier par thème (jetons, CSS, réglages d'animation). Le choix dans Paramètres viendra ensuite.
export const THEMES = [{ id: "rapport", label: "Rapport" }];
export const ACTIVE_THEME = "rapport";

const KEY = "airthermo-color-mode";
// Le site public, la connexion et les rapports partagés restent toujours en clair
const PUBLIC = /^\/($|pompe-a-chaleur|mentions-legales|le-cabinet|politique-de-confidentialite|admin|invitation|rapport-agents|r\/)/;
const DARK_QUERY = window.matchMedia("(prefers-color-scheme: dark)");
const resolve = (mode) => (mode === "auto" ? (DARK_QUERY.matches ? "dark" : "light") : mode);
const apply = (mode) => {
  document.documentElement.dataset.theme = resolve(mode);
  document.documentElement.dataset.skin = ACTIVE_THEME;
};
apply(PUBLIC.test(window.location.pathname) ? "light" : localStorage.getItem(KEY) || "light");

export const THEME_MODES = [{ id: "light", label: "Clair" }, { id: "dark", label: "Sombre" }, { id: "auto", label: "Auto" }];

// Choix enregistré sur le compte de l'utilisateur (copie locale pour un affichage immédiat au chargement)
export function useThemeMode() {
  const { user, setUser } = useAuth();
  const mode = user?.theme || localStorage.getItem(KEY) || "light";
  const [systemDark, setSystemDark] = useState(DARK_QUERY.matches);
  useEffect(() => { apply(mode); localStorage.setItem(KEY, mode); }, [mode, systemDark]);
  useEffect(() => {
    const onChange = (e) => setSystemDark(e.matches);
    DARK_QUERY.addEventListener("change", onChange);
    return () => DARK_QUERY.removeEventListener("change", onChange);
  }, []);
  const setMode = useCallback((m) => {
    setUser((u) => (u ? { ...u, theme: m } : u));
    api.patch("/auth/me/preferences", { theme: m }).catch(() => {});
  }, [setUser]);
  const dark = resolve(mode) === "dark";
  const toggleTheme = useCallback(() => setMode(dark ? "light" : "dark"), [dark, setMode]);
  return { mode, dark, setMode, toggleTheme };
}
